export default __webpack_public_path__ + "static/media/lock.2a52b339.png";